import { FEATURE_TYPE } from '@/constants/features';
import { createOverlayLineFeature } from '@/components/Map/MapViewer/utils/config/overlaysLayer/createOverlayLineFeature';
import { LinePoint } from '@/types/reactions';
import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import { SimpleGeometry } from 'ol/geom';
import type { MarkerLine } from 'minerva-plugin-api';

export const getMarkerLineFeatures = (
  markers: MarkerLine[],
  { pointToProjection }: { pointToProjection: UsePointToProjectionResult },
): Feature<SimpleGeometry>[] =>
  markers.map(marker => {
    const feature = createOverlayLineFeature([marker.start, marker.end] as LinePoint, {
      color: marker.color,
      pointToProjection,
    });
    feature.set('id', marker.id);
    feature.set('type', FEATURE_TYPE.LINE_MARKER);
    return feature;
  });
